import React from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

const TransitionLink = ({children, direction, to, className, state}) => {
    return (
        <AniLink
            to={to}
            cover
            state={state}
            direction={direction || 'left'}
            bg={'#14073a'}
            duration={0.9}
            activeClassName="active"
            className={className}>
            {children}
        </AniLink>
    )
}

export default TransitionLink;